import { render } from "./App.vue?vue&type=template&id=49cf9d8a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49cf9d8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49cf9d8a', __exports__)) {
    api.reload('49cf9d8a', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=49cf9d8a", () => {
    api.rerender('49cf9d8a', render)
  })

}


export default __exports__